import { defineComponent as f, useSlots as y, openBlock as a, createBlock as r, unref as o, mergeProps as m, withCtx as d, createSlots as g, renderSlot as s, createCommentVNode as u, createElementVNode as v, createVNode as B, createElementBlock as h } from "vue";
import k from "./ghl-ui.es400.js";
import { downloadFromDOM as D } from "./ghl-ui.es71.js";
import "./ghl-ui.es24.js";
import "./ghl-ui.es401.js";
import U from "./ghl-ui.es178.js";
import $ from "./ghl-ui.es402.js";
import C from "./ghl-ui.es74.js";
import I from "./ghl-ui.es239.js";
import N from "./ghl-ui.es403.js";
const S = { class: "hl-upload-icon" }, x = { key: 0 }, L = f({
  name: "UIUpload"
}), P = f({
  ...L,
  props: {
    multiple: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    fileList: {
      type: Array,
      default: () => []
    },
    max: Number,
    type: {
      type: String,
      default: "draggable"
    },
    buttonProps: Object,
    showDownloadButton: Boolean,
    accept: String,
    onDownload: Function
  },
  emits: ["change", "remove", "update:file-list", "download"],
  setup(e, { emit: p }) {
    const c = e, b = p, i = y(), w = (t) => t ? c.onDownload ? (b("download", t), !1) : (D(t), !1) : null;
    return (t, n) => (a(), r(o($), m({ "list-type": "image" }, t.$attrs, {
      accept: e.accept,
      "file-list": e.fileList,
      max: e.max,
      multiple: e.multiple,
      disabled: e.disabled,
      "show-download-button": e.showDownloadButton,
      onChange: n[0] || (n[0] = (l) => t.$emit("change", l)),
      onDownload: w,
      onRemove: n[1] || (n[1] = (l) => t.$emit("remove", l)),
      "onUpdate:fileList": n[2] || (n[2] = (l) => t.$emit("update:file-list", l))
    }), {
      default: d(() => [
        e.type == "button" ? (a(), r(o(C), m({
          key: 0,
          id: `hl-upload__button-type__${o(I)()}`
        }, e.buttonProps), g({
          default: d(() => [
            o(i).buttonContent ? s(t.$slots, "buttonContent", { key: 0 }, void 0, !0) : u("", !0)
          ]),
          _: 2
        }, [
          o(i).buttonIcon ? {
            name: "icon",
            fn: d(() => [
              s(t.$slots, "buttonIcon", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["id"])) : (a(), r(o(N), { key: 1 }, {
          default: d(() => [
            v("div", S, [
              B(o(k), { class: "text-gray-600" })
            ]),
            o(i).extra ? (a(), h("div", x, [
              s(t.$slots, "extra", {}, void 0, !0)
            ])) : u("", !0)
          ]),
          _: 3
        }))
      ]),
      _: 3
    }, 16, ["accept", "file-list", "max", "multiple", "disabled", "show-download-button"]));
  }
}), G = /* @__PURE__ */ U(P, [["__scopeId", "data-v-3821944c"]]);
export {
  G as default
};
